import du from '../utils/dom-utilities';

const displayCommanditeFieldset = (target = null) => {
    if (!target) {
        return;
    }

    if (target.querySelector('.js-sponsor-form-radioBtn').checked) {
        target.querySelector('.js-sponsor-form-commandite').classList.remove('form-hidden');
        target.querySelector('.js-sponsor-form-commandite-error').classList.remove('form-hidden');
    } else {
        target.querySelector('.js-sponsor-form-commandite').classList.add('form-hidden');
        target.querySelector('.js-sponsor-form-commandite-error').classList.add('form-hidden');
    }
};
export default function radioBtnDisplayCommanditeFieldset() {
    du.queryAll('.js-sponsor-form-radioBtnCommandite').forEach((item) => {
        displayCommanditeFieldset(item);
        du.onEvent(item, 'change', function() {
                displayCommanditeFieldset(item);
        });
    });
}



// WEBPACK FOOTER //
// ./src/main/js/components/sponsorForm.js